<style scoped >
.row .v-input--checkbox {
  display: inline-block;
  margin-right: 25px;
}
</style>
<template>
<div class='row' >
  <v-subheader class='overline pa-0' >Locations</v-subheader>
  <v-checkbox dense hide-details row class='mt-0'
    v-for='location in locations'
    v-model='selected'
    v-bind='attrs'
    :key="location.id"
    :value='location.id'
    :label='location.name' />

  <div class='caption grey--text' v-if='hint' v-text='hint' />

  <div class='caption warning--text'
    v-if='warningMessage'
    v-text='warningMessage' />

  <template v-if='errorMessages && errorMessages.length > 0' >
    <div class='caption error--text'
      v-for='error in errorMessages'
      v-text='error' />
  </template>

</div>
</template>
<script>
export default {
  name: 'LocationPicker',
  props: {
    spaceId: { required: false },
    value: { type: Array },
    attrs: { type: Object, default: () => { return {} } },
    hint: { type: String, required: false },
    required: { type: Boolean, default: false },
    showArchived: { type: Boolean, default: false },
    errorMessages: { type: Array, default: () => { return [] } }
  },
  data () {
    return {
      selected: [],
      warningMessage: null
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.selected = this.value
      }
    },
    selected: {
      immediate: true,
      handler () {
        this.setDefaultValue()
        this.$emit('input', this.selected)
      }
    },
    locations: {
      immediate: true,
      handler () {
        this.setDefaultValue()
      }
    }
  },
  methods: {
    setDefaultValue () {
      if (this.required === true && !this.hasSelectedValue && this.locations && this.locations.length > 0) {
        this.selected = [this.locations[0].id]
        this.warningMessage = 'You must select at least one location'
        this.$emit('input', this.selected)
      }
    }
  },
  computed: {
    locations () {
      let locs = this.$store.getters.getLocations
      if (this.spaceId) {
        locs = this.$store.getters.getLocationsBySpaceId(this.spaceId)
      }
      return locs
    },
    hasSelectedValue () {
      return (this.selected && this.selected.length > 0)
    }
  }
}
</script>



// WEBPACK FOOTER //
// LocationPicker.vue?46f60926